
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { mapGetters } from 'vuex'

import { ROUTES } from '@router'

export default {
  components: {
    RevButtonBase,
    RevIllustration,
    RevCard,
  },
  computed: {
    ROUTES: () => ROUTES,
    ...mapGetters({
      buyingGuide: 'landing/buyingGuide',
    }),
    trackingName() {
      return this.$route.name
    },
  },
}
